$(document).ready(function() {
    // Get the data string of the hidden element
    var skusForVisualizer = $('#skusForVisualizer').val();

    // remove spaces from string
    skusForVisualizer = skusForVisualizer.trim();

    // Convert string to array
    var skusArray = skusForVisualizer.split(',');

    /**
    * Function to choose a random element from the array
    * @param {Array} arr Array of product ID
    * @returns {string} - Random SKU
    */
    function getRandomSku(arr) {
        var randomIndex = Math.floor(Math.random() * arr.length);
        return arr[randomIndex];
    }

    /**
    * Function to update sku in href that contain roomvo.startStandaloneVisualizer
    * @param {Array} newID Array of product ID
    */
    function updateVisualizerLinks(newID) {
        // Select all links that contain roomvo.startStandaloneVisualizer
        $('a[href*="roomvo.startStandaloneVisualizer"]').each(function(index) {
            // Get random SKU
            var randomSku = getRandomSku(newID);
            // Update the attribute witn a new sku
            if (randomSku) {
                var newHref = $(this).attr('href').replace(/skuRandomVisualizer/, randomSku);
                $(this).attr('href', newHref);
                $(this).addClass('roomvo-gtm');
                $(this).attr('data-gtm-sku', randomSku);
            }
        });
    }
    updateVisualizerLinks(skusArray);
})
